import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateView } from '@americanexpress/data-manager-utils';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { setErrorReporterSessionData } from '@americanexpress/one-app-ducks';
import getSafeLocaleData from '../../utils/getSafeLocaleData';

const AmexDDLViewHandler = () => {
  const updateView = useUpdateView();
  const activeLocale = useSelector(getActiveLocaleSelector);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (activeLocale) {
      const {
        activeLocale: locale, language, country,
      } = getSafeLocaleData(activeLocale);
      updateView({
        locale,
        country,
        language,
      });
      dispatch(setErrorReporterSessionData({ activeLocale: locale }));
    }
  }, [activeLocale]);
  return null;
};

export default AmexDDLViewHandler;
